import { ModelUsageInfo } from "../models/modelUsageInfo";
import { BasicResponse } from "./basicResponse";

export class AnalyzeCSVResponse extends BasicResponse{
    public fileDefinition?: AnalyzerFileDefinition;
    public modelUsageInfo?: ModelUsageInfo;
}

export class AnalyzerFileDefinition{
    public id?:number;
    public name!:string;
    public hasHeader!:boolean;
    public fieldDelimiter?:string;
    public unevenRows?:boolean;
    public fields:AnalyzerFieldDefinition[] = [];
}

export class AnalyzerFieldDefinition{
    public index!:number;
    public fieldName!:string;
    public dataType!:string;
    public dataPattern?:string;
    public fieldLength?:number;
    public mandatory:boolean = false;
    public isOutputParameter:boolean = false;
    public category?:string;
    public businessContext?:string;
    public validationRules?:string;
}